import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const LeagueSelectorBar = ({
  orderedLeagues,
  selectedLeagues,
  onLeagueClick,
  onScrollLeft,
  onScrollRight,
  leagueListRef
}) => {
  return (
    <div className="mt-3 mx-auto w-full flex items-center justify-center gap-0">
      <Button
        type="text"
        icon={<LeftOutlined />}
        onClick={onScrollLeft}
        className="!text-[#006719] !min-w-[24px] !h-[24px] !p-0 !mr-1"
      />
      <div
        className="flex w-fit max-w-[min(1080px,calc(100vw-80px))] items-center justify-start gap-2 overflow-x-auto p-0 bg-transparent border-0 rounded-none"
        ref={leagueListRef}
      >
        {orderedLeagues.map((league) => (
          <button
            key={league.id}
            type="button"
            className={`w-[108px] h-[68px] shrink-0 rounded-[8px] border bg-white flex items-center justify-center cursor-pointer transition-all duration-200 ${
              selectedLeagues.includes(league.id)
                ? 'border-2 border-[#0f8a36]'
                : 'border border-[#d7d7d7]'
            }`}
            onClick={() => onLeagueClick(league.id)}
          >
            <img src={league.logo} alt={league.name} className="max-w-[86%] max-h-[86%] object-contain" />
          </button>
        ))}
      </div>
      <Button
        type="text"
        icon={<RightOutlined />}
        onClick={onScrollRight}
        className="!text-[#006719] !min-w-[24px] !h-[24px] !p-0 !ml-1"
      />
    </div>
  );
};

export default LeagueSelectorBar;

